<template>
    <div ref='scroll'  style='overflow:hidden;width:100%;height:100%'>
            <slot></slot>
    </div>
</template>


<script>
    export default{
        name:"scroll",

        data:function(){
            return {

            }
        },

        mounted:function(){

            this.$nextTick(function() {

            setTimeout(() => {
               
                $(this.$refs.scroll).mCustomScrollbar({
                    theme: "dark",
                    scrollbarPosition: "inside",
                    autoHideScrollbar: true,
                    mouseWheel: { preventDefault: true },
                    advanced: { updateOnContentResize: true }
                });
            }, 0)
        })


        }


    } // fim default

</script>


<style lang="stylus">
    @import "./../css/variaveis"

</style>